import React, { useState, useEffect } from 'react';
import P, { InferProps } from 'prop-types';
import { SxStyle } from '../../../types';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { ColorResult, ChromePicker, MaterialPicker } from 'react-color';

const styles: SxStyle = {
  root: {
    marginLeft: '-6px',
    display: 'flex',
    alignItems: 'center',
  },
  popover: {
    position: 'absolute',
    zIndex: '2',
  },
  cover: {
    position: 'fixed',
    top: '0px',
    right: '0px',
    bottom: '0px',
    left: '0px',
  },
  edit: {
    textDecoration: 'underline',
  },
  colorCard: {
    width: '100px',
    height: '120px',
  },
};

function ColorField({ setChange, field, isReadOnly }: InferProps<typeof ColorField.propTypes>) {
  const [colorHex, setColorHex] = useState(field.value);
  const [showColorPicker, setShowColorPicker] = useState(false);

  useEffect(() => {
    setColorHex(field.value);
  }, [field]);

  const handleChange = (newColor: ColorResult) => {
    if (isReadOnly) {
      return;
    }

    setColorHex(newColor.hex);

    if (newColor && setChange) {
      setChange(field.key, `${newColor.hex}`, field.validation, field.isTeamDataValue);
    }
  };

  return (
    <>
      <Typography variant="subtitle2">{field.title}</Typography>
      <Stack direction={'row'} spacing={4}>
        <Card
          style={{ backgroundColor: colorHex }}
          sx={styles.colorCard}
          raised={true}
          elevation={4}
        />
        <MaterialPicker color={colorHex} onChangeComplete={handleChange} />
      </Stack>
      {!isReadOnly && (
        <Link
          sx={styles.edit}
          component="button"
          variant="caption"
          onClick={() => setShowColorPicker(true)}
        >
          {'Editera'}
        </Link>
      )}
      {showColorPicker ? (
        <Box sx={styles.popover}>
          <Box sx={styles.cover} onClick={() => setShowColorPicker(false)} />
          <ChromePicker color={colorHex} onChangeComplete={handleChange} />
        </Box>
      ) : (
        <></>
      )}
    </>
  );
}

ColorField.propTypes = {
  field: P.shape({
    title: P.string.isRequired,
    id: P.string.isRequired,
    type: P.string,
    validation: P.any.isRequired,
    key: P.string.isRequired,
    value: P.string.isRequired,
    isTeamDataValue: P.bool,
  }).isRequired,
  setChange: P.func,
  isReadOnly: P.bool,
};

export default React.memo(ColorField);
